module.exports = {
  replaceTplImagePath(str) {
    let content = str;
    if (content) {
      content = content.replace(
        /"http:\/\/img.gohappy\.com\.tw\/tpl/gi,
        '"https://img.shopping.friday.tw/tpl'
      );
      content = content.replace(
        /("\/tpl)/gi,
        '"https://img.shopping.friday.tw/tpl'
      );
      return content;
    }
    return '';
  },
  replaceWidthAndHeight(str) {
    let content = str;
    if (content) {
      content = content.replace(/height:\s?\d+px;?/gi, '');
      content = content.replace(/(width):\s?\d+px;?/gi, 'width:100%;');
      content = content.replace(/(height="(\d+)")/gi, '');
      content = content.replace(/(width="(\d+)")/gi, 'width="100%"');
      return content;
    }
    return '';
  },
  replaceContentTagStyle(str) {
    let content = str;
    if (content) {
      content = content.replace(/(style="([\d\w;:-]+)")/gi, '');
      return content;
    }
    return '';
  },
  getCookie(name) {
    const Url = {
      // public method for url encoding
      encode: function (string) {
        return escape(this._utf8_encode(string));
      },
      // public method for url decoding
      decode: function (string) {
        return this._utf8_decode(string);
      },
      // private method for UTF-8 encoding
      _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, '\n');
        var utftext = '';
        for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
            utftext += String.fromCharCode(c);
          } else if (c > 127 && c < 2048) {
            utftext += String.fromCharCode((c >> 6) | 192);
            utftext += String.fromCharCode((c & 63) | 128);
          } else {
            utftext += String.fromCharCode((c >> 12) | 224);
            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
            utftext += String.fromCharCode((c & 63) | 128);
          }
        }
        return utftext;
      },
      // private method for UTF-8 decoding
      _utf8_decode: function (utftext) {
        var string = '';
        var i = 0,
          c2,
          c3;
        var c = (c2 = 0);
        while (i < utftext.length) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
            string += String.fromCharCode(c);
            i++;
          } else if (c > 191 && c < 224) {
            c2 = utftext.charCodeAt(i + 1);
            string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
            i += 2;
          } else {
            c2 = utftext.charCodeAt(i + 1);
            c3 = utftext.charCodeAt(i + 2);
            string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
            i += 3;
          }
        }
        return string;
      },
    };

    var mycookie = document.cookie.split('; ');
    for (var i = 0; i < mycookie.length; i++) {
      var cookie1 = mycookie[i].split('=');
      if (cookie1[0] === name) {
        return Url.decode(cookie1[1]);
      }
    }
    return null;
  },
};
